module.exports = __webpack_public_path__ + "bd31e01ab30a68c93998f4b7f4ee4305.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1080.jpg
// module id = 451
// module chunks = 0